// src/pages/PaymentPage.js
import { useLocation } from "react-router-dom";
import PayNowButton from "../components/PayNowButton";

const PaymentPage = () => {
  const { state } = useLocation();
  const lead = state;

  if (!lead) {
    return (
      <div className="p-4 text-center">
        <h2 className="text-xl font-semibold">No lead information found</h2>
        <p className="mt-2">Please go back and select a quotation to pay</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Complete Your Payment</h2>

      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <h3 className="font-semibold text-lg">
          {lead.registerNumber || "Vehicle"}
        </h3>
        <p className="text-gray-600 mt-1">
          {lead.make} • {lead.model || "N/A"}
        </p>

        <div className="mt-4 pt-4 border-t">
          <div className="flex justify-between font-medium">
            <span>Quotation Amount:</span>
            <span>₹{lead.quotationAmount || "0"}</span>
          </div>
        </div>
      </div>

      <PayNowButton
        upiId="sktamang@okhdfcbank"
        amount={lead.quotationAmount || 0}
        leadId={lead._id}
      />
    </div>
  );
};

export default PaymentPage;
